<template>
    <div class="noticeInfo_wrap">
        <el-page-header @back="goBack" ></el-page-header>
        <div class="notice_content">
            <div class="notice_title">
                {{content.noticeTitle}}
            </div>
            <div class="notice_info flex-around">
                <div>
                    <span>通知时间：</span>
                    <span>{{content.sendTime}}</span>
                </div>
                <div>
                    <span>通知人：</span>
                    <span>{{content.senderName}}</span>
                </div>
            </div>
            <div class="notice_text">
                <div v-html="content.richText"></div>
            </div>
             <div class="addition_file" v-if="fileUrl[1]">
                附件下载：<a :href="fileUrl[1]" target="_blank">{{fileUrl[0]}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                content: this.$store.state.content,
                fileUrl:['','']
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
            this.getFileLink()
        },
        methods: {
            goBack(){
                this.$router.replace(`/personalCenter?modeId=3`)
            },

            getFileLink(){
                this.fileUrl = [decodeURIComponent(this.content.file).split('/').pop().substr(15),this.content.file]
                this.content.richText = this.content.richText.replace(/<img/g,"<img style='max-width:100%;height:auto;'");
            }
        }
    }
</script>

<style lang="scss" scoped>
.noticeInfo_wrap{
    background: #F3F6FF;
    padding:30px 0px;
}
.notice_content{
    margin:0px 15% ;
    background: white;
    box-sizing: border-box;
    box-shadow: 0px 3px 4px rgba(140, 166, 255, 0.16);
    .addition_file{
        padding: 20px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
        color: #848484;
    }
    .notice_title{
        padding: 20px 0px;
        font-size: 35px;
        text-align: center;
        color: #5277F7;
        border-bottom: 2px solid #5277F7;
        font-weight: bold;
    }
    .notice_info{
        font-size: 20px;
        color: #848484 ;
        padding: 15px 15%;
    }
    .notice_text{
        padding:50px 100px;
        box-sizing: border-box;
        min-height: 550px;
        line-height: 1.7;
    }
}
</style>

